import React from 'react';
import bannerPerson from '../../../assets/images/banner-person.png';
import { useIntl } from 'react-intl';
import { useTranslatedNavigate } from '../../../utils/routes';
import translations from '../../../translations/main.json';
import messages from './messages';

const Banner = (props: any) => {
  const { name, showPriceButton, style = {}, isAccountPage } = props;
  const { formatMessage } = useIntl();
  const translatedNavigate = useTranslatedNavigate();

  const redirectTo = () => {
    translatedNavigate(
      '/' +
        translations['cc4.seo.route.account'] +
        '/' +
        translations['cc4.seo.route.my-premium']
    );
  };

  return (
    <div className="premium-banner" style={style}>
      <div className="banner-content">
        <div className="banner-text-section">
          <h2 className="banner-title">
            {formatMessage(messages.bannerTitle, { name })}
          </h2>
          <h2 className="banner-title-small-screen">
            {formatMessage(messages.bannerMobileTitle)}
          </h2>
          <p className="banner-description">
            {formatMessage(
              isAccountPage ? messages.priceContent : messages.bannerSubTitle
            )}
          </p>
          {showPriceButton && (
            <button onClick={redirectTo} className="banner-cta">
              {formatMessage(messages.bannerPriceButtonLabel)}
            </button>
          )}
        </div>
        <div className="banner-image-section" style={{ position: 'relative' }}>
          <img src={bannerPerson} alt="" className="banner-person" />
          <div className="speech-bubble">
            <span>{formatMessage(messages.noCommissionLabel)}</span>
            <div className="speech-bubble-pointer" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
